export default "__VITE_ASSET__DKLmiz1f__"